import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// Store
import { IRootState } from '../../redux';
import { setSearchValue, setSearchInputText, setSearchOutsideMailbox } from '../../redux/mailbox/actions';
// Assets
import images from '../../assets/images/images';
// Helpers
import { isMediaSizeLessThanMD } from '../../helpers/layout';
// Config
import { ConfigContext } from '../../providers';
// Styles
import styles from './mailsearch.module.scss';
import { Image, Input, SpriteImage } from '..';

interface IMailSearchState {
    searchValue: string;
}

interface IMailSearchProps {
    show: boolean;
    isMailbox?: boolean;
}

class MailSearch extends React.Component<ReduxType, IMailSearchState> {
    constructor(props: ReduxType) {
        super(props);
        this.state = {
            searchValue: this.props.searchInputText ? this.props.searchInputText : '',
        };
    }
    componentDidUpdate(prevProps: Readonly<ReduxType>, prevState: Readonly<IMailSearchState>, snapshot?: any): void {
        if (prevProps.searchInputText != this.props.searchInputText) {
            this.setState({ searchValue: this.props.searchInputText });
        }
        if (this.props.searchInputText.trim().length == 0) {
            this.props.setSearchValue('');
        }
    }

    search = (event: React.MouseEvent) => {
        event && event.stopPropagation();
        event && event.preventDefault();
        if (!this.props.isMailbox) {
            this.props.setSearchOutsideMailbox(true);
            this.props.setSearchValue(this.state.searchValue.trim());
            this.props.history.push('/mailbox');
        } else {
            this.props.setSearchValue(this.state.searchValue.trim());
        }
    };

    handleError = (value: string) => {
        this.setState({ searchValue: value });
        this.props.setSearchInputText(value.trim());
        return '';
    };

    handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            const input = event.target as HTMLInputElement;
            this.setState({ searchValue: input.value });
            this.props.setSearchInputText(input.value.trim());
            this.search(null);
        }
    };

    public render() {
        return (
            <ConfigContext.Consumer>
                {(config): JSX.Element => (
                    <>
                        {this.props.show ? (
                            !isMediaSizeLessThanMD(this.props.mediaSize) ? (
                                <div className={['d-flex flex-fill', styles.searchInput].join(' ')}>
                                    <Input
                                        value={this.state.searchValue}
                                        ariaLabelledBy="search_button"
                                        autoComplete
                                        type="search"
                                        name="search"
                                        placeholder="FIND_DOCUMENTS"
                                        errorHandler={this.handleError}
                                        onKeyDown={this.handleKeyDown}
                                        maxLength={50}
                                    />
                                    <div
                                        className={styles.searchButton}
                                        style={{ backgroundColor: config.colors.buttons.primary.background }}
                                    >
                                        <div
                                            role="button"
                                            id="search_button"
                                            tabIndex={0}
                                            className="d-flex align-items-center justify-content-center w-100 h-100 prevFocusedElem"
                                            onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.click()}
                                            onClick={this.search}
                                        >
                                            <Image src={images.search} alt="SEARCH" />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className={['d-flex w-100 align-items-center', styles.mobileSearch].join(' ')}>
                                    <Input
                                        className={styles.mobileSearchInput}
                                        ariaLabelledBy="search_button"
                                        value={this.state.searchValue}
                                        autofocus
                                        autoComplete
                                        type="search"
                                        name="searchMobile"
                                        placeholder="FIND_DOCUMENTS"
                                        errorHandler={this.handleError}
                                        onKeyDown={this.handleKeyDown}
                                        maxLength={50}
                                    />
                                    <div
                                        role="button"
                                        id="search_button"
                                        tabIndex={0}
                                        className="d-flex align-items-center justify-content-center prevFocusedElem"
                                        onClick={this.search}
                                    >
                                        <SpriteImage className={styles.searchIcon} />
                                    </div>
                                </div>
                            )
                        ) : null}
                    </>
                )}
            </ConfigContext.Consumer>
        );
    }
}

const mapDispatcherToProps = (dispatch: Dispatch) => {
    return {
        setSearchValue: (value: string) => dispatch(setSearchValue(value)),
        setSearchInputText: (text: string) => dispatch(setSearchInputText(text)),
        setSearchOutsideMailbox: (enabled: boolean) => dispatch(setSearchOutsideMailbox(enabled)),
    };
};

const mapStateToProps = ({ appReadouts, mailbox }: IRootState) => {
    return {
        mediaSize: appReadouts.mediaSize,
        searchValue: mailbox.searchValue,
        searchInputText: mailbox.searchInputText,
    };
};

type ReduxType = IMailSearchProps &
    ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatcherToProps> &
    RouteComponentProps;

export default withRouter(connect(mapStateToProps, mapDispatcherToProps)(MailSearch));
